import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateOrAddMessageOptimized } from '../../../../actions/inbox/messagesOptimizedActions';

/**
 * Hook optimizado para acciones de mensajes con service layer
 * Solo métodos optimizados para grandes volúmenes
 */
const useMessageActions = () => {
  const dispatch = useDispatch();

  // Agregar nuevo mensaje (optimizado para grandes volúmenes)
  const addMessage = useCallback(async (message) => {
    return await dispatch(updateOrAddMessageOptimized(message));
  }, [dispatch]);

  // Actualizar mensaje existente (optimizado para grandes volúmenes)
  const updateMessage = useCallback(async (messageUpdates) => {
    return await dispatch(updateOrAddMessageOptimized(messageUpdates));
  }, [dispatch]);

  return {
    addMessage,
    updateMessage
  };
};

export default useMessageActions;